document.addEventListener('DOMContentLoaded', render);

function render() {
    const eventCalendar = document.getElementById('event-calendar');

    if (eventCalendar) {
        fetch('/wp-json/custom/v1/events')
            .then(response => response.json())
            .then(events => {
                let html = /*html*/`
                    <table class="event-calendar-table"><thead></thead><tbody>
                `;
                const date = new Date();
                const parts = [
                    date.getFullYear(), 
                    String(date.getMonth()).padStart(2, "0") + 1, 
                    String(date.getDate()).padStart(2, "0"),                 ]
                const currentDate = parts.join("-");

                events.filter((event) => {
                    return event.event_date >= currentDate; 
                }).forEach((event, index) => {
                    console.log(event)
                    html += /*html*/`
                        <tr>
                            <td><p>${event.name}</p></td>
                            <td><p>${formatDate(event.event_date)}</p></td>
                            <td class="text-end">${event.flyer_url ? 
                                /*html*/`<a class="event-button" href="${event.flyer_url}">Meer info</a>` : ""
                            }</td>
                        </tr>
                        <tr><td colspan="3"><div class="divider ${index % 2 === 0 ? "red" : "green"}"></div></td></tr>
                    `
                });
                html += "</tbody></table>";
                console.log(html)
                eventCalendar.innerHTML = html;
            }).catch((e) => {
                console.error(e)
                eventCalendar.innerHTML = "<p>Momenteel zijn er geen evenementen gepland.</p>"
            })
    }
}

function formatDate(d) {
    const year = d.slice(0, 4);
    const month = [
        "Januari",
        "Februari",
        "Maart",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "December"
    ][Number(d.slice(5, 7)) - 1];
    
    const day = d.slice(8, 10);
    return `${day} ${month} ${year}`;
}